import { HelmetDexteel } from "@dexteel/mesf-core";
import { KPIShiftReport } from "./components/KPIShiftReport";

export const KPIShiftReportPage = () => {
	return (
		<>
			<HelmetDexteel title="KPI Shift Report" />
			<KPIShiftReport />
		</>
	);
};
